<template>
  <!-- Figma Code Connect target: node-id="2:2955" -->
  <div class="fonctionnalites" data-model-id="2:2955">
    <NavSubsection />
    <HeroSubsection />
    <IntroSubsection />
    <FeatureBlocksSubsection />
    <FooterSubsection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavSubsection from "./Fonctionnalites/sections/NavSubsection.vue";
import IntroSubsection from "./Fonctionnalites/sections/IntroSubsection.vue";
import FeatureBlocksSubsection from "./Fonctionnalites/sections/FeatureBlocksSubsection.vue";
import FooterSubsection from "./Fonctionnalites/sections/FooterSubsection.vue";

export default defineComponent({
  name: "Fonctionnalites",
  components: {
    NavSubsection,

    IntroSubsection,
    FeatureBlocksSubsection,
    FooterSubsection,
  },
});
</script>

<style>
.fonctionnalites {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .fonctionnalites :is(
      .hero-subsection,
      .intro-subsection,
      .feature-section,
      .features-subsection,
      .cta-subsection
    ) {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .fonctionnalites .feature-section .section-inner {
    flex-direction: column !important;
    gap: 24px !important;
  }

  .fonctionnalites :is(.feature-content, .feature-image, .feature-list) {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 768px) {
  .fonctionnalites :is(
      .hero-subsection,
      .intro-subsection,
      .feature-section,
      .features-subsection,
      .cta-subsection
    ) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
</style>
